import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/image-upload.svg";
var ImageUploadOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ImageUploadOutline_default as default
};
